import { FormControl, FormGroup } from "@angular/forms";
import moment from "moment";

export interface PromoDetails {
    promoID: number | null
    promoName: string | null;
    promoType: string | null;
    promoPrice: string | null;
    promoPercent: string | null;
    customerNumber: string | null;
    customerName: string | null;
    endCustomer: string | null;
    endCustomersId: string | null;
    transferPrice: string | null;
    currency: string | null;
    rebateAmount: number | null;
    msrpCurrency: string | null;
    promoUnitsForecast: string | null;
    promoAmount: string | null;
    fiscalWeekStartDate: Date | null;
    fiscalWeekEndDate: Date | null;
    salesperson: string | null;
    miscEventDetail: string | null;
    saleUnit: string | null;
    promoUnitsClaimed: string | null;
    paidAmount: string | null;
    promoDetails: number | null;
    priceHolderName: string | null;
    fundNumber: number | null;
    fundName: number | null;
    stackable: number | null;
    marketPlace: string | null;
    msrp: string | null;
    programName: string | null;
    deviatedFromProgram: string | null;
    ds: number | null;
    productIds: string | null;
    storeIds: string | null;
    promoTerms: number | null;
    promoCode: string | null;
    source: string | null;
    maximumDiscount: string | null;
    advertisingChannel: string | null;
    promoStartDate: Date | null;
    promoEndDate: Date | null;
    programNumber: string | null;
    promoComments: string | null;
    promoEventDetails: string | null;
    active: boolean | false;
    country: string | null;
    region: string | null;
    productName: string | null;
    productCode: string | null;
    priceListName: string | null;
    productLine: string | null;
    publicationStartDate: Date | null;
    publicationEndDate: Date | null;
    publicationType: string | null;
    publicationName: string | null;
    [key: string]: any
}

/* Default object  */
export const PromoDefaultData: PromoDetails = {
    promoID: 0,
    promoName: null,
    promoType: null,
    promoPrice: null,
    promoPercent: null,
    customerNumber: null,
    customerName: null,
    endCustomer: null,
    endCustomersId: null,
    transferPrice: null,
    currency: null,
    rebateAmount: 0,
    msrpCurrency: null,
    promoUnitsForecast: null,
    promoAmount: null,
    fiscalWeekStartDate: new Date,
    fiscalWeekEndDate: new Date,
    salesperson:null,
    miscEventDetail: null,
    saleUnit: null,
    promoUnitsClaimed:null,
    paidAmount:null,
    promoDetails: null,
    priceHolderName: null,
    fundNumber: null,
    fundName: null,
    stackable: null,
    marketPlace: null,
    msrp: null,
    programName: null,
    deviatedFromProgram: null,
    ds: null,
    productIds: null,
    storeIds: null,
    promoTerms: null,
    promoCode: null,
    source: null,
    maximumDiscount: null,
    advertisingChannel: null,
    promoStartDate: new Date,
    promoEndDate: new Date,
    programNumber: null,
    promoComments: null,
    promoEventDetails: null,
    country: null,
    region: null,
    productName: null,
    productCode: null,
    priceListName: null,
    productLine: null,
    active: false,
    publicationStartDate: new Date ,
    publicationEndDate: new Date ,
    publicationType: null,
    publicationName: null
}

export type PromoFormGroup = FormGroup<{ [K in keyof PromoDetails]: FormControl<PromoDetails[K]> }>;